export function TermsOfUsePage() {
  return (
    <>
      <h1>Terms of Use</h1>

      <h2>1. Scope and Applicability</h2>
      <p>These Terms of Use govern the access to and use of the spcfy platform (available at www.spcfy.io), operated by:</p>
      <p>
        spcfy GmbH
        <br />
        Niemeyerstraße 1<br />
        04179 Leipzig
        <br />
        Germany
        <br />
        Email: info@spcfy.io
      </p>
      <p>By registering an account or using any service on the platform, users accept and agree to be bound by these Terms of Use.</p>

      <h2>2. User Account and Registration</h2>
      <ul>
        <li>Access to most services requires registration of a user account.</li>
        <li>Users are required to provide accurate, complete, and up-to-date information during registration.</li>
        <li>Users are responsible for maintaining the confidentiality of their login credentials.</li>
        <li>spcfy reserves the right to suspend or terminate accounts in cases of misuse, non-compliance, or fraudulent activity.</li>
      </ul>

      <h2>3. Services Provided</h2>
      <p>
        spcfy offers a digital platform for the processing, analysis, and interpretation of DNA sequencing data, with services including:
      </p>
      <ul>
        <li>Upload and processing of high-throughput sequencing files derived from Illumina platforms</li>
        <li>Bioinformatic preprocessing using tools such as VSEARCH and Cutadapt</li>
        <li>Creation of order-specific OTU databases</li>
        <li>
          Long-term storage of laboratory and sequencing metadata (e.g., laboratory protocols, primer information, sequencing technology and
          chemistry)
        </li>
        <li>Metadata handling and integration</li>
        <li>Visualization of analysis results</li>
        <li>Machine learning-based prediction tools</li>
      </ul>
      <p>Services are offered either:</p>
      <ul>
        <li>Sample-based (per order), or</li>
        <li>Through a subscription model, depending on user selection.</li>
      </ul>

      <h2>4. User Obligations</h2>
      <ul>
        <li>They possess all necessary rights and permissions to upload and process any submitted data.</li>
        <li>No unlawful, offensive, or malicious content will be uploaded.</li>
        <li>Users will not attempt to bypass platform security, misuse the service, or reverse-engineer proprietary functionality.</li>
        <li>Any violations of these obligations may result in the suspension or deletion of the user account.</li>
      </ul>

      <h2>5. Data Ownership and Usage</h2>
      <ul>
        <li>Users retain full ownership and intellectual property rights over their uploaded sequencing data and associated metadata.</li>
        <li>spcfy does not claim any rights of ownership over user content.</li>
        <li>
          Users grant spcfy a non-exclusive right to process submitted data solely for the purpose of delivering the requested services.
        </li>
        <li>
          With explicit opt-in consent, spcfy may use aggregated and anonymized data (e.g., OTUs and metadata) to train internal machine
          learning and prediction models hosted on secure infrastructure within the European Union (AWS).
        </li>
      </ul>

      <h2>6. Availability and Modifications</h2>
      <ul>
        <li>spcfy strives to provide reliable, uninterrupted service but does not guarantee continuous uptime.</li>
        <li>Downtime may occur due to maintenance, technical upgrades, or external disruptions.</li>
        <li>Features of the platform may be added, changed, or removed at any time without prior notice.</li>
      </ul>

      <h2>7. Limitation of Liability</h2>
      <p>spcfy is not liable for any damages, including loss of data or indirect consequences, arising from:</p>
      <ul>
        <li>User error</li>
        <li>Misuse of the platform</li>
        <li>Technical failures beyond spcfy&apos;s control</li>
        <li>Misinterpretation of output or third-party reliance on results</li>
      </ul>
      <p>Liability is only assumed in cases of gross negligence or willful misconduct as defined under applicable law.</p>

      <h2>8. Termination</h2>
      <ul>
        <li>Users may terminate their account at any time by deleting it via the user interface or by written request.</li>
        <li>spcfy reserves the right to suspend or delete accounts in the event of legal violations, misuse, or breach of these Terms.</li>
        <li>Upon termination, user data may be deleted in accordance with applicable data retention policies and the Privacy Policy.</li>
      </ul>

      <h2>9. Changes to the Terms</h2>
      <ul>
        <li>spcfy may update these Terms of Use from time to time.</li>
        <li>Users will be notified of significant changes and may be asked to re-confirm acceptance.</li>
        <li>Continued use of the platform after such updates constitutes agreement to the revised terms.</li>
      </ul>

      <h2>10. Applicable Law and Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of the Federal Republic of Germany.
        <br />
        The exclusive place of jurisdiction is Leipzig, Germany, unless mandatory consumer protection laws provide otherwise.
      </p>
    </>
  )
}
